export default "__VITE_ASSET__DfqvtUdO__"